import { FC, useContext } from 'react';
import { GroupedDataPieChart } from '../../../../../../Components/Charts';
import { useGetCompanyBcmsByStatusQuery } from '../../../../../../store';
import { CompanyDashboardContext } from '../../../../Utils';
import { emptyGuid } from '../../../../../../models';
import { DataFilterContext } from '../../../../../../Contexts';

const COLOR_PALLET = new Map([
    ['Issued', '#BFBFBF'],
    ['Scheduled', '#97CBD2'],
    ['Pending', '#57585A'],
]);

export const CompanyDashboardBCMTabSidebarContent: FC = () => {
    const { company } = useContext(CompanyDashboardContext);
    const {
        statusFilter,
        reminderFilter,
        approvedByFilter,
        scheduledFromDateFilter: fromDateFilter,
        scheduledToDateFilter: toDateFilter,
        periodStartDateFilter,
        periodEndDateFilter,
        setStatusFilter,
        studyFilter
    } = useContext(DataFilterContext);
    const { data: workItemStats, isLoading } = useGetCompanyBcmsByStatusQuery({ companyId: company.id ?? emptyGuid, searchParams: {
        status: statusFilter,
        reminder: reminderFilter,
        approvedBy: approvedByFilter,
        fromDate: fromDateFilter ?? undefined,
        toDate: toDateFilter ?? undefined,
        periodStartDate: periodStartDateFilter ?? undefined,
        periodEndDate: periodEndDateFilter ?? undefined,
        assignedToStudyId: studyFilter
    }});

    return <GroupedDataPieChart name='BCM Status' groupedData={workItemStats ?? []} onSliceClicked={setStatusFilter} colorMap={COLOR_PALLET} isLoading={isLoading} />;
};